import { render, staticRenderFns } from "./lay-out-app.vue?vue&type=template&id=31279de8&scoped=true"
import script from "./lay-out-app.vue?vue&type=script&lang=js"
export * from "./lay-out-app.vue?vue&type=script&lang=js"
import style0 from "./lay-out-app.vue?vue&type=style&index=0&id=31279de8&prod&lang=scss&scoped=true"
import style1 from "./lay-out-app.vue?vue&type=style&index=1&id=31279de8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31279de8",
  null
  
)

export default component.exports